jQuery(function ($) {

    
    function toggleNav() {
        var navIsVisible = (!$('.cd-dropdown').hasClass('dropdown-is-active')) ? true : false;
        $('.cd-dropdown').toggleClass('dropdown-is-active', navIsVisible);
        $('.cd-dropdown-trigger').toggleClass('dropdown-is-active', navIsVisible);
        $('#menuDropDown').attr('aria-hidden', 'false');
         //setTimeout(function() { $('#topOfMenu').find('li').filter(':visible').first().find('a').focus(); }, 300);
        if (!navIsVisible) {
            $('.cd-dropdown').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('.has-children ul').addClass('is-hidden');
                $('.move-out').removeClass('move-out');
                $('.is-active').removeClass('is-active');
                $('#menuDropDown').attr('aria-hidden', 'true');
            });
        }
    }

    //open/close mega-navigation
    $('#menuTrigger').on('click', function (event) {
        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
        toggleNav();
        return false;
    });

    $(document).one('click', function closeMenu(e) {    
        if ($('#menuTrigger').has(e.target).length === 0) {
            $('#menuTrigger').removeClass('open-to-left');
        } else {
            $(document).one('click', closeMenu);
        }

    });

    //close meganavigation
    $('.cd-dropdown .cd-close').on('click', function (event) {
        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
        toggleNav();
        return false;
    });

    //on mobile - open submenu
    $('.has-children').children('a').on('click', function (event) {
        //prevent default clicking on direct children of .has-children  
        var selected = $(this);

        if (!isSubmenuInViewport(selected.next('ul'))) {
            event.preventDefault();
            $("#topOfMenu").scrollTop(0);
            selected.next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('move-out');
        }
    });

    //on desktop - differentiate between a user trying to hover over a dropdown item vs trying to navigate into a submenu's contents
    var submenuDirection = (!$('.cd-dropdown-wrapper').hasClass('open-to-left')) ? 'right' : 'left';
    $('.cd-dropdown-content').menuAim({
        activate: function (row) {
        	// This will sometimes run on FF and Edge at page load, without this check it will overlay the menu without making it visible. 
        	if($('.cd-dropdown').hasClass('dropdown-is-active')) {
			$(row).children().addClass('is-active').removeClass('fade-out').attr('aria-hidden', 'false');
	            if ($('.cd-dropdown-content .fade-in').length === 0) $(row).children('ul').addClass('fade-in');
	
	            $('img', $(row)).each(function () {
	                if ($(this).is('[data-lazy]')) {
	                    var src = $(this).attr('data-lazy');
	                    $(this).attr('src', src).removeAttr('data-lazy').fadeIn(500);
	                }
	            });
            }
        },
        deactivate: function (row) {
            $(row).children().removeClass('is-active').attr('aria-hidden', 'true');
            if ($('li.has-children:hover').length === 0 || $('li.has-children:hover').is($(row))) {
                $('.cd-dropdown-content').find('.fade-in').removeClass('fade-in');
                $(row).children('ul').addClass('fade-out');
            }
        },
        exitMenu: function () {
            $('.cd-dropdown-content').find('.is-active').removeClass('is-active');
            return true;
        },
        submenuDirection: submenuDirection
    });

    //submenu items - go back link
    $('.go-back').on('click', function () {
        var selected = $(this),
			visibleNav = $(this).parent('ul').parent('.has-children').parent('ul');
        selected.parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('move-out');
    });
    
    	// if a sublink is hidden, make sure screen reader doesn't announce it as a number in the list
	$('ul.cd-secondary-dropdown li').each(function() {
		if ($(this).css('display') == 'none') {
			$(this).attr('aria-hidden', 'true');
		}
		else { $(this).removeAttr('aria-hidden'); }
	});

    var mn = $(".main-nav"),
    mns = "main-nav-scrolled",
    hdr = $('header').height();



    $(window).scroll(function () {
        if ($(this).scrollTop() > hdr) {
            mn.addClass(mns);
        } else {
            mn.removeClass(mns);
        }
    });

});

function isSubmenuInViewport(el) {
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}